import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useContent } from "../lib/content";
import { Shield, ArrowLeft, Mail } from "lucide-react";

export default function Privacy() {
  const { tField } = useI18n();
  const { content } = useContent();
  const p = content?.privacy;

  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-10 py-12 lg:py-20">
      <Link
        to="/"
        data-testid="privacy-back-link"
        className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#94A3B8] hover:text-white mb-10"
      >
        <ArrowLeft className="h-3 w-3" strokeWidth={2} />
        Back
      </Link>

      <div className="flex items-start gap-4 mb-3">
        <div className="h-10 w-10 border border-[#3B82F6] text-[#3B82F6] flex items-center justify-center shrink-0">
          <Shield className="h-5 w-5" strokeWidth={1.5} />
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#64748B] mb-2">
            // LEGAL · PRIVACY POLICY
          </div>
          <h1
            data-testid="privacy-title"
            className="font-display text-4xl lg:text-5xl tracking-tight text-white"
            style={{ fontWeight: 800 }}
          >
            {tField(p?.title) || "Privacy Policy"}
          </h1>
          {p?.updated && (
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#64748B] mt-3">
              {tField(p.updated)}
            </div>
          )}
        </div>
      </div>

      {p?.intro && (
        <p className="text-sm text-[#94A3B8] leading-relaxed max-w-3xl mt-8 mb-12">
          {tField(p.intro)}
        </p>
      )}

      <div className="space-y-5">
        {(p?.sections || []).map((s, i) => (
          <article
            key={i}
            data-testid={`privacy-article-${i}`}
            className="bg-[#0F1525] border border-[#1E2A3F] hover:border-[#3B82F6]/40 transition-colors p-6"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="font-mono text-[10px] text-[#3B82F6] tabular-nums">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h2 className="font-display text-lg tracking-tight text-white" style={{ fontWeight: 700 }}>
                {tField(s.title)}
              </h2>
            </div>
            <p className="text-sm text-[#94A3B8] leading-relaxed pl-7">{tField(s.body)}</p>
          </article>
        ))}
      </div>

      {p?.footnote && (
        <div className="mt-12 border-t border-[#1E2A3F] pt-6 flex items-start gap-3 text-sm text-[#94A3B8]">
          <Mail className="h-4 w-4 mt-0.5 text-[#3B82F6] shrink-0" strokeWidth={1.5} />
          <p className="leading-relaxed">{tField(p.footnote)}</p>
        </div>
      )}
    </div>
  );
}
